module.exports = __webpack_public_path__ + "img/upload-close.08932231.svg";